import {createStylesParams, StyleParamType, wixColorParam, wixFontParam} from '@wix/tpa-settings'
import {StyleType} from '@wix/editor-platform-ooi-metadata-resolver'

import {colorMetadata, fontMetadata, numberMetadata} from '../../../../../../utils/builderMetadata'

export type GeneralStylesParams = {
  backgroundColor: StyleParamType.Color
  borderColor: StyleParamType.Color
  borderWidth: StyleParamType.Number
  borderRadius: StyleParamType.Number
  breadcrumbsFont: StyleParamType.Font
  breadcrumbsColor: StyleParamType.Color
  titleFont: StyleParamType.Font
  titleColor: StyleParamType.Color
  subtitleFont: StyleParamType.Font
  subtitleColor: StyleParamType.Color
  bodyTextFont: StyleParamType.Font
  bodyTextColor: StyleParamType.Color
}

export const generalStyleParams = createStylesParams<GeneralStylesParams>({
  backgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1', 1),
    metadata: colorMetadata(StyleType.backgroundColor, 'color-1', 1),
  },
  borderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0),
    metadata: colorMetadata(StyleType.borderColor, 'color-5', 0),
  },
  borderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: numberMetadata(StyleType.borderWidth, {defaultValue: 0}),
  },
  borderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: numberMetadata(StyleType.borderRadius, {defaultValue: 0}),
  },
  breadcrumbsFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {size: 16}),
    metadata: fontMetadata('Body-M', 16),
  },
  breadcrumbsColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: colorMetadata(StyleType.color, 'color-5'),
  },
  titleFont: {
    type: StyleParamType.Font,
    getDefaultValue: (params) =>
      wixFontParam('Page-title', {
        htmlTag: 'h1',
        size: params.isMobile ? 28 : 32,
      })(params),
    metadata: fontMetadata('Page-title', 32, 28),
  },
  titleColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: colorMetadata(StyleType.color, 'color-5'),
  },
  subtitleFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Page-title', {size: 16, htmlTag: 'h2'}),
    metadata: fontMetadata('Page-title', 16),
  },
  subtitleColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: colorMetadata(StyleType.color, 'color-5'),
  },
  bodyTextFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {size: 16}),
    metadata: fontMetadata('Body-M', 16),
  },
  bodyTextColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: colorMetadata(StyleType.color, 'color-5'),
  },
})
